import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, map, Observable, of } from 'rxjs';
import { EmployeeAccessTypes, LanguageTypes } from '@shared/enums';

export interface CreateEmployeeRequest {
  NameFirst: string;
  NameLast: string;
  EmailAddress: string;
  PhoneNumber: string;
  AccessType?: EmployeeAccessTypes;
  LanguageType?: LanguageTypes;
  Pin?: string;
  MerchantId: number;
  LocationId: number;
}

export interface UpdateEmployeeRequest {
  EmployeeId: number;
  NameFirst: string;
  NameLast: string;
  EmailAddress: string;
  PhoneNumber: string;
  AccessType: EmployeeAccessTypes;
  LanguageType?: LanguageTypes;
  Pin?: string;
  LocationId: number;
}

@Injectable({
  providedIn: 'root',
})
export class EmployeeService extends BaseApiService {
  private readonly employeeEndpoint = `/v2/Employees`;

  findByMerchantId(merchantId: number): Observable<any> {
    return this.get(`${this.employeeEndpoint}/merchant/${merchantId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  findByIdAndMerchantId(employeeId: number, merchantId: number): Observable<any> {
    return this.get(`${this.employeeEndpoint}/${employeeId}/merchant/${merchantId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  create(createEmployeeRequest: CreateEmployeeRequest): Observable<any> {
    return this.post(this.employeeEndpoint, createEmployeeRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  update(employeeId: number, updateEmployeeRequest: UpdateEmployeeRequest): Observable<any> {
    return this.patch(`${this.employeeEndpoint}/${employeeId}`, updateEmployeeRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  impersonate(employeeId: number): Observable<any> {
    return this.post(`${this.employeeEndpoint}/${employeeId}/Impersonate`, {}).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  resendWelcomeEmail(employeeId: number): Observable<boolean> {
    return this.post(`${this.employeeEndpoint}/${employeeId}/ResendWelcomeEmail`, {}).pipe(
      map(() => true),
      catchError((err) => {
        console.error(err);
        return of(false);
      })
    );
  }
}
